import { cardPageImages } from 'components/pages/Card/images';
import { CardsTabType } from 'components/pages/Card/model/types';
import { FC } from 'react';
import styles from '../Card.module.scss';

type Props = {
  tab: CardsTabType;
  setTab: (tab: CardsTabType) => void;
};

const TabButton: FC<{ type: CardsTabType; active: boolean; onClick: () => void }> = ({
  active,
  type,
  onClick,
}) => {
  const imageUri =
    type === 'area'
      ? active
        ? cardPageImages.tabAreaActive
        : cardPageImages.tabAreaInactive
      : active
      ? cardPageImages.tabMissionActive
      : cardPageImages.tabMissionInactive;
  return (
    <div onClick={onClick} className={styles.tabButton}>
      <img src={imageUri} alt={type} />
    </div>
  );
};

export const CardTabs: FC<Props> = ({ tab, setTab }) => {
  return (
    <div className={styles.tabs}>
      <TabButton type="area" active={tab === 'area'} onClick={() => setTab('area')} />
      <TabButton type="mission" active={tab === 'mission'} onClick={() => setTab('mission')} />
    </div>
  );
};
